import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { SdvorButtonComponent, SdvorGenericLinkComponent } from '../../components';
import { ProcessLinkModule } from '../../directives';
import { SdvorSharedCmsComponents } from '../cms-components.enum';
import { ButtonComponent } from './button.component';

@NgModule({
  declarations: [ButtonComponent],
  imports: [
    NgIf,
    AsyncPipe,
    IconModule,
    ProcessLinkModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [SdvorSharedCmsComponents.RosaButtonComponent]: {
          component: ButtonComponent,
        },
      },
    }),
    SdvorButtonComponent,
    SdvorGenericLinkComponent,
  ],
  exports: [ButtonComponent],
})
export class ButtonModule {}
